import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BaseService, CommonService, Extension, ResponseResult, TemplateType } from 'sv-shared';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class TramDoGiaTriDoService extends BaseService {
  constructor(http: HttpClient, injector: Injector, private _commonService: CommonService,) {
    super(http, injector, `${environment.apiDomain.thmpEndpoint}/tramdogiatrido`);
  }

  find(model: any): Promise<ResponseResult> {
    const apiUrl = `${this.serviceUri}/find`;
    return this._http
      .post<ResponseResult>(`${apiUrl}`, model).pipe(catchError(err => this.handleError(err, this._injector))).toPromise();
  }

  getsReportByMonth(model: any): Promise<ResponseResult> {
    const apiUrl = `${this.serviceUri}/GetsReportByMonth`;
    return this._http
      .post<ResponseResult>(`${apiUrl}`, model).pipe(catchError(err => this.handleError(err, this._injector))).toPromise();
  }

  exportReportByMonth(model: any) {
    const apiUrl = `${this.serviceUri}/ExportReportByMonth`;
    return this._http
      .post(apiUrl, model, { responseType: 'blob' as 'json' })
      .pipe(catchError((err: HttpErrorResponse) => this._commonService.handleError(err, this._injector)))
      .subscribe(res => {
        this.saveAsExcelFile(res, 'baocaothang');
      });
  }

  public saveAsExcelFile(buffer: any, fileName: string) {
    const data: Blob = new Blob([buffer], {
      type: TemplateType.EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + Extension.EXCEL_EXTENSION);
  }

  getForTvDashboard(idTramDo: number): Promise<ResponseResult> {
    const apiUrl = `${this.serviceUri}/GetForTvDashboard/${idTramDo}`;
    return this.defaultGet(apiUrl);
  }

}
